var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"outlined":"","clearable":"","items":_vm.data,"item-text":"text","item-value":"value","value":_vm.value,"label":_vm.$t(_vm.model.title),"error-messages":_vm.error,"disabled":_vm.disabled},on:{"change":function($event){return _vm.updateData($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }